import { cn } from "@omni/utils/styles";

import { Amount } from "@/components/Product/Amount/amount.component";

import { useDeliveryContext } from "../../context/delivery.context";

type Props = {
    className?: string;
};

export const Base = ({ className }: Props) => {
    const {
        roundingValue,
        activeDelivery,
        activeQuantity,
        isUpdatingCart,
        minimumOrderQuantity,
        changeQuantity
    } = useDeliveryContext();

    return (
        <Amount
            className={cn(className)}
            roundingValue={roundingValue}
            activeDelivery={activeDelivery}
            isUpdatingCart={isUpdatingCart}
            minimumOrderQuantity={minimumOrderQuantity}
            value={activeQuantity}
            onQuantityChange={(value) => changeQuantity(value)}
        />
    );
};
